import React from 'react';
import ChristmasCelebration2024 from 'views/ChristmasCelebration2024';
const MathClubPage = () => {
  return <ChristmasCelebration2024/>;
};

export default MathClubPage;

